// Tiny GA4 helper. Safe no-op when gtag is not yet installed.
// Measurement ID is loaded via index.html.

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackEvent(name: string, params: Record<string, unknown> = {}): void {
  try {
    if (typeof window === 'undefined') return;
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    } else {
      // queue into dataLayer so it fires once gtag.js loads
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...params });
    }
  } catch {
    // never throw from analytics
  }
}
